// extracted by mini-css-extract-plugin
export default {"burgerBtn":"BurgerBtn_burgerBtn__33JCZ"};